export function scrollPage() {
  window.scrollTo({
    top: document.getElementById('slider').getBoundingClientRect().top,
    behavior: "smooth",
  })
}